<template>
	<ParamDispatcher
		v-bind="$attrs"
		v-on="$listeners"
		:node="paramDispatcherDataProvider"
		:nodeService="service"
		:nodeAction="action"
		:param="mappedParam"
		:key="buildFieldKey(param)"
		:hasEditPermissions="hasEditPermissions"
	/>
</template>

<script>
import ParamDispatcher from '@/components/BlockEditor/BlockEditorParams/ParamDispatcher.vue';
import ParamsService from '@/utils/ParamsService';
export default {
	name: 'ConditionalRenderingField',
	props: {
		param: { type: Object },
		paramsMap: { type: Object },
		paramsMapLabels: { type: Object },
		credentialsConfiguration: { type: Object },
		service: { type: Object },
		action: { type: Object },
		hasEditPermissions: { type: Boolean, default: true },
		/** need to provide either contextId or nodeId to be used in ExternalSourceMixinService,
		 *  by those props we decide which resource we use to retrieve options */
		contextId: { type: Number },
		nodeId: { type: Number },
	},
	components: { ParamDispatcher },
	computed: {
		credentialsConfigurationValue() {
			return this.credentialsConfiguration.credentials;
		},
		mappedParam() {
			return { ...this.param, disable_mapped_data: true };
		},
		paramDispatcherDataProvider() {
			return {
				params_map: this.paramsMap,
				params_map_labels: this.paramsMapLabels,
				credentials_configuration: this.credentialsConfiguration,
				credentials: this.credentialsConfigurationValue,
				overrideParamsMap: true,
				placementContextId: this.contextId,
				id: this.nodeId,
			};
		},
	},
	methods: {
		buildFieldKey(param) {
			return ParamsService.buildFieldKey(param, this.paramsMap);
		},
	},
};
</script>

<style lang="scss" scoped></style>
